module.exports = __webpack_public_path__ + "assets/img/teacher (33).571fbcc7.png";